import React from "react";
import { ImageConstants } from "./Utils/Constants/ImageConstants";
function PageNotFound() {
  return (
    <div className="loginComponent">
      <div className="rectangle p-5">
        <div className="row">
          <img src={ImageConstants?.Page404} alt="" />
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
